import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { MainAppState } from "../appState/models";
import { ProgramModal } from "./models";
import { isNotEmpty } from "../../../helpers/utils";

export const programSelector = createDraftSafeSelector(
  (state: MainAppState) => state,
  (state: MainAppState) => state.program.program,
);

export const programStatusSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.programStatus,
);

export const programCreatedDateSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.programCreatedDate,
);

export const programDeliverableCountrySelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.programDeliverableCountry,
);

export const bulkActivitySelectedParticipantsSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.bulkActivitySelectedParticipants,
);

export const bulkActivityProgramTemplateIdSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.bulkActivityProgramTemplateId,
);

export const bulkActivityListSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.bulkActivityList,
);

export const bulkTransferSelectedParticipantsSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.bulkTransferSelectedParticipants,
);

export const bulkTransferSelectedStoreParticipantsSelector =
  createDraftSafeSelector(
    programSelector,
    (state: ProgramModal) => state.bulkTransferSelectedStoreParticipants,
  );

export const programBillingCountryIdSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.billingCountryId,
);

export const bulkTransferSearchInputClickSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) =>
    (() => {
      const productLineId = state.bulkTransferSearchInputValues?.productLineId;
      return productLineId && isNotEmpty(productLineId) ? true : false;
    })(),
);

export const bulkTransferSearchInputSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.bulkTransferSearchInputValues,
);

export const programOpcoFieldEditableSelector = createDraftSafeSelector(
  programSelector,
  (state: ProgramModal) => state.areOpcoFieldsEditable,
);
